
import React from 'react';

export const WhyChooseSection: React.FC = () => {
  const differentials = [
    {
      icon: 'ri-user-heart-line',
      title: 'Atendimento Personalizado',
      description: 'Contador dedicado que conhece seu negócio',
      details: 'Cada cliente tem um contador responsável que acompanha de perto as necessidades específicas da empresa, oferecendo soluções personalizadas.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Tecnologia e Segurança',
      description: 'Sistemas modernos com backup em nuvem',
      details: 'Utilizamos as mais modernas ferramentas de gestão contábil com total segurança dos dados e backup automático em nuvem.'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Experiência Multissetorial',
      description: 'Comércio, serviços, indústria, startups e liberais',
      details: 'Atendemos diversos segmentos empresariais com conhecimento específico das particularidades de cada setor.'
    },
    {
      icon: 'ri-notification-3-line',
      title: 'Suporte Proativo',
      description: 'Alertas de prazos e oportunidades antes dos vencimentos',
      details: 'Sistema de alertas automáticos para prazos fiscais e identificação proativa de oportunidades de economia tributária.'
    }
  ];

  return (
    <section id="diferenciais" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-[#1A3A52] mb-6 font-['Playfair_Display']">
            Por Que Escolher a Conte
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nossos diferenciais fazem toda a diferença no sucesso do seu negócio
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {differentials.map((item, index) => (
            <div key={index} className="flex items-start space-x-6">
              <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-white text-2xl`}></i>
              </div>
              
              <div>
                <h4 className="text-xl font-semibold text-[#1A3A52] mb-3">
                  {item.title}
                </h4>
                <p className="text-[#00A896] font-medium mb-3">
                  {item.description}
                </p>
                <p className="text-gray-600 leading-relaxed">
                  {item.details}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Client Segments */}
        <div className="mt-20 bg-[#F8F9FA] rounded-2xl p-12">
          <h4 className="text-3xl font-bold text-[#1A3A52] text-center mb-8 font-['Playfair_Display']">
            Empresas Que Atendemos
          </h4>
          
          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-6 text-center">
            <div className="p-4">
              <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-user-line text-white text-xl"></i>
              </div>
              <div className="text-sm font-medium text-[#1A3A52]">MEI</div>
            </div>
            
            <div className="p-4">
              <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-store-line text-white text-xl"></i>
              </div>
              <div className="text-sm font-medium text-[#1A3A52]">Micro e Pequenas</div>
            </div>
            
            <div className="p-4">
              <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-building-line text-white text-xl"></i>
              </div>
              <div className="text-sm font-medium text-[#1A3A52]">Médias Empresas</div>
            </div>
            
            <div className="p-4">
              <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-rocket-line text-white text-xl"></i>
              </div>
              <div className="text-sm font-medium text-[#1A3A52]">Startups</div>
            </div>
            
            <div className="p-4">
              <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shopping-cart-line text-white text-xl"></i>
              </div>
              <div className="text-sm font-medium text-[#1A3A52]">E-commerce</div>
            </div>
            
            <div className="p-4">
              <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-briefcase-line text-white text-xl"></i>
              </div>
              <div className="text-sm font-medium text-[#1A3A52]">Profissionais Liberais</div>
            </div>
          </div>
          
          <p className="text-center text-gray-600 mt-8">
            Também atendemos ONGs, associações e outros tipos de organizações
          </p>
        </div>
      </div>
    </section>
  );
};
